import { useState } from "react";

import TermsConditionsModal from "./TermsConditionsModal";

import ReferBusinessIcon from "assets/images/refer_business.svg";
import BookSessionIcon from "assets/images/book_session.svg";
import EarnCreditIcon from "assets/images/earn_credit.svg";

import "./HowItWorks.scss";

function HowItWorks() {
  const [termsModalOpen, setTermsModalOpen] = useState(false);

  return (
    <div className="how-it-works-section">
      <div className="flex justify-between items-center custom-margin-bottom-18px">
        <h2 className="section-title">How it works</h2>
        <button className="read-terms-button" type="button" onClick={() => setTermsModalOpen(true)}>
          Read full terms
        </button>
      </div>

      <div className="steps-grid">
        <div className="flex flex-col items-start gap-125">
          <div className="step-icon">
            <img src={ReferBusinessIcon} alt="Refer a business" />
          </div>
          <div className="step-content">
            <h3 className="step-title">Refer a business</h3>
            <p className="step-description">Share your referral link or invite them by email — as many as you like.</p>
          </div>
        </div>

        <div className="flex flex-col items-start gap-125">
          <div className="step-icon">
            <img src={BookSessionIcon} alt="They book a session and hire" />
          </div>
          <div className="step-content">
            <h3 className="step-title">They book a session and hire</h3>
            <p className="step-description">Your referral books a session through Edge and makes their first hire.</p>
          </div>
        </div>

        <div className="flex flex-col items-start gap-125">
          <div className="step-icon">
            <img src={EarnCreditIcon} alt="You earn a $2,000 reward" />
          </div>
          <div className="step-content">
            <h3 className="step-title">You earn a $2,000 reward</h3>
            <p className="step-description">Once their new hire stays for 90 days, you'll receive a $2,000 reward.</p>
          </div>
        </div>
      </div>

      <TermsConditionsModal open={termsModalOpen} onClose={() => setTermsModalOpen(false)} />
    </div>
  );
}

export default HowItWorks;
